import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getInformationNeighborsById } from '../../../../api/information/queries/getInformationNeighborsById';
import { IInformation } from '../../../../interfaces/Information.interfaces';

interface IUseGetInformationNeighborsByIdQueryParams {
  informationId: string;
}

export const useGetInformationNeighborsByIdQuery = ({ informationId }: IUseGetInformationNeighborsByIdQueryParams) => {
  return useQuery<IInformation[], AxiosError>(
    ['infomation_neighbors_by_id', informationId],
    () => getInformationNeighborsById({ informationId }),
    {
      enabled: Boolean(informationId),
    },
  );
};
